import type { Action } from 'redux';
import { type ParseSpreadsheetAction, SpreadsheetActionTypes } from './actions';
import type { GenericSheet } from './parser/types';

export interface ISpreadsheetState<T = null> {
  spreadsheet: GenericSheet<T> | null;
}

export const spreadSheetInitialState: ISpreadsheetState = {
  spreadsheet: null,
};

const assertNever = (action: Action): never => {
  throw new Error(`This action should never reach the spreadsheetReducer. Action: ${action}.`);
};

export const spreadsheetReducer = (state: ISpreadsheetState = spreadSheetInitialState, action: ParseSpreadsheetAction): ISpreadsheetState => {
  if (!(action.type in SpreadsheetActionTypes)) {
    return state;
  }
  switch (action.type) {
    case SpreadsheetActionTypes.PARSE_SPREADSHEET_START:
    case SpreadsheetActionTypes.PARSE_SPREADSHEET_FAIL: {
      return {
        ...state,
        spreadsheet: null,
      };
    }

    case SpreadsheetActionTypes.PARSE_SPREADSHEET_SUCCESS: {
      return {
        ...state,
        spreadsheet: action.payload,
      };
    }

    default: {
      return assertNever(action);
    }
  }
};
